// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dialog-body[data-v-2707f6f6] {
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/dialogs/DialogBody.vue"],"names":[],"mappings":";AAOA;AACA","sourcesContent":["<template>\n  <div class=\"dialog-body\">\n    <slot />\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.dialog-body {\n}\n</style>\n\n<script>\nexport default {\n  name: 'DialogBodyComponent',\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
